import { Box, Button, Typography } from '@material-ui/core'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import ReservationRequestForm from './ReservationRequestForm'

const ReservationEditModal = ({ reservationId, onClose, onSaved }) => {
  const [reservation, setReservation] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [reload, setReload] = useState(0)
  useEffect(() => {
    let active = true
    setLoading(true)
    setError('')
    setReservation(null)
    axios
      .get(`vehicle-reservations/manage/${reservationId}`)
      .then(({ data }) => {
        if (!data.success || !data.data) throw new Error('Reservation unavailable')
        if (!active) return
        if (data.data.status !== 'pending') setError('Vetëm kërkesat në pritje mund të modifikohen.')
        else setReservation(data.data)
      })
      .catch((requestError) => {
        if (active) setError(requestError.response?.data?.message || 'Rezervimi nuk u ngarkua. Provoni përsëri.')
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [reservationId, reload])

  if (reservation)
    return (
      <ReservationRequestForm
        reservation={reservation}
        onClose={onClose}
        onSaved={onSaved}
        onReloadReservation={() => setReload((previous) => previous + 1)}
      />
    )

  return (
    <Modal show onHide={onClose} className='modal-1' size='lg' aria-labelledby='edit-reservation-title'>
      <Modal.Header closeButton>
        <Modal.Title id='edit-reservation-title'>Modifiko rezervimin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Typography role='status'>Duke ngarkuar rezervimin…</Typography>}
        {error && (
          <Box>
            <Typography role='alert' color='error'>
              {error}
            </Typography>
            <Button onClick={() => setReload((previous) => previous + 1)}>Provo përsëri</Button>
          </Box>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Mbyll</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReservationEditModal
